import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack} from "@mui/material";
import TextFieldWithSetValue from "../../../../textfield/TextFieldWithSetValue";
import ButtonExit from "../../../../button/ButtonExit";
import ButtonAdd from "../../../../button/ButtonAdd";

const ModalSetTrimming = ({
                              open,
                              onClose,
                              title,
                              values,
                              setValues,
                              labelButtonSSubmit,
                              handleSubmit,
                              loading
                          }) => {
    return (
        <Dialog open={open}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Stack
                        sx={{
                            width: '100%',
                            minWidth: {xs: '300px', sm: '360px', md: '400px'},
                            gap: '0.5rem',
                        }}
                    >
                        <TextFieldWithSetValue
                            label="Отступ слева"
                            values={values}
                            setValues={setValues}
                            field={'trimmingLeft'}
                        />
                        <TextFieldWithSetValue
                            label="Отступ справа"
                            values={values}
                            setValues={setValues}
                            field={'trimmingRight'}
                        />
                        <TextFieldWithSetValue
                            label="Отступ сверху"
                            values={values}
                            setValues={setValues}
                            field={'trimmingTop'}
                        />
                        <TextFieldWithSetValue
                            label="Отступ снизу"
                            values={values}
                            setValues={setValues}
                            field={'trimmingBottom'}
                        />
                    </Stack>
                </form>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit
                    text={"Выйти"} onClick={onClose}/>
                <ButtonAdd
                    loading={loading}
                    text={labelButtonSSubmit}
                    onClick={handleSubmit}
                />
            </DialogActions>
        </Dialog>
    );
};

export default ModalSetTrimming;